<template>
  <div>
    <b-alert :show="true" variant="light">
      <div class="iq-alert-text">
        <p class="mb-0">{{ roleName }}</p>
        <p class="fs-700 mb-0">
          {{ roleInfo.name }} <br />{{ roleInfo.street }} {{ roleInfo.suburb }}
          <br />{{ roleInfo.postCode }} {{ roleInfo.state }}
        </p>
      </div>
    </b-alert>
  </div>
</template>

<script>
export default {
  name: 'WDDealer',
  props: ['roleName', 'roleInfo']
}
</script>
